import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  arrayOf, exact, func, number, string,
} from 'prop-types';
import { debounce } from 'debounce';
import { Flex, Input, Icon } from '@atoms';
import { ReactComponent as SearchIcon } from '@assets/search.svg';

const Search = ({ listItems, onSearch }) => {
  const [inputValue, setInputValue] = useState('');

  const applySearchToItems = debounce(searchSubstring => {
    const filteredItemsIds = listItems.reduce((acc, listItem) => {
      // make search case-insensitive
      if (listItem.name.toLowerCase().includes(searchSubstring.toLowerCase())) {
        acc.push(listItem.id);
      }
      return acc;
    }, []);

    onSearch(filteredItemsIds);
  }, 300);

  const handleInputChange = e => {
    const userInput = e.target.value;
    setInputValue(userInput);
    applySearchToItems(userInput);
  };

  return (
    <Wrapper padding="sm">
      <Flex column justifyCenter>
        <Icon SVG={SearchIcon} width="30px" height="30px" />
      </Flex>
      <Input
        type="text"
        id="options-search"
        name="options-search"
        placeholder="Search"
        value={inputValue}
        onChange={handleInputChange}
      />
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  ${({ theme: { color, typography } }) => css`
    width: 100%;
    position: relative;

    ${Flex} {
      height: 100%;
      position: absolute;
      top: 0;
      left: 32px;
    }

    ${Input} {
      border-radius: 20px;
      border: none;
      background-color: ${color.dust};
      padding-left: 45px;
      text-indent: -30px;
      font-weight: ${typography.weight.medium};

      &::placeholder {
        color: ${color.black};
        font-weight: ${typography.weight.medium};
      }
    }
  `}
`;

Search.propTypes = {
  listItems: arrayOf(exact({
    id: number.isRequired,
    name: string.isRequired,
  })).isRequired,
  onSearch: func.isRequired,
};

export default Search;
